// Display-only persona metadata for the settings sidebar.
// Full persona text and voice config live server-side in server/quiz-agent-config.ts.

export type PersonaDisplayProfile = {
  id: string;
  label: string;
  emoji: string;
  description: string;
};

export const PERSONA_DISPLAY_PROFILES: PersonaDisplayProfile[] = [
  { id: "default", label: "ברירת מחדל", emoji: "👩‍🏫", description: "קול המורה הרגיל לתרגול אוצר מילים." },
  { id: "merav",   label: "מרב",         emoji: "👩‍🏫", description: "מתרגלים אוצר מילים עם המורה מרב." },
  { id: "nir",     label: "ניר",          emoji: "👨‍🏫", description: "מתרגלים אוצר מילים עם המורה ניר." },
];
